var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0728 44.999H0.743304V14.9555H10.0728V44.999ZM5.40301 10.8573C2.41975 10.8573 0 8.38627 0 5.40301C2.13529e-08 3.97004 0.569244 2.59577 1.58251 1.58251C2.59577 0.569244 3.97005 0 5.40301 0C6.83598 0 8.21026 0.569244 9.22352 1.58251C10.2368 2.59577 10.806 3.97004 10.806 5.40301C10.806 8.38627 8.38527 10.8573 5.40301 10.8573ZM44.99 44.999H35.6806V30.374C35.6806 26.8885 35.6103 22.4186 30.83 22.4186C25.9795 22.4186 25.2362 26.2055 25.2362 30.1229V44.999H15.9167V14.9555H24.8645V19.0537H24.9951C26.2406 16.6932 29.2831 14.2021 33.8223 14.2021C43.2643 14.2021 45 20.4198 45 28.4956V44.999H44.99Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c89377bd522ad0ae7e59a644cbaa688d.svg";
export { ForwardRef as ReactComponent };